module.exports = __webpack_public_path__ + "static/media/back3.206e8aae.png";